module.exports = __webpack_public_path__ + "img/House_3_Brick_Veneer.9a1f2099.jpg";